import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-16 bg-white" data-id="element-92">
      <div className="container mx-auto px-4 max-w-3xl text-center" data-id="element-93">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-nutri-mint/10 border border-nutri-mint/30 rounded-3xl p-8 md:p-12 flex flex-col items-center" data-id="element-94">
          <div className="bg-nutri-medium p-4 rounded-full text-white mb-6" data-id="element-95">
            <ShieldCheck size={48} data-id="element-96" />
          </div>
          <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4" data-id="element-97">
            Garantía total de 30 días
          </h2>
          <p className="text-gray-700 text-lg leading-relaxed max-w-2xl" data-id="element-98">
            Si en 30 días sentís que estas planillas no te ahorran tiempo ni
            mejoran la organización de tu consultorio, te devolvemos el 100% de
            tu dinero. Sin formularios, sin justificaciones, sin demoras.
          </p>
        </motion.div>
      </div>
    </section>;
}